<template>
  <div class="flex flex-col space-y-4 lg:space-y-6 px-4 sm:px-0">
    <NamiLatestUpdatesNew noLink :items="36" />
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp();
const locale = nuxtApp.$i18n.global.locale;

const config = useRuntimeConfig();
const title = ref("Latest Updates");
const description = ref(
  "Stay up to date with the latest chapters published on NamiComi.",
);
const canonical = ref(`${config.public.baseUrl}/en/updates/latest`);
definePageMeta({ title: "Latest Updates" });

useHead({
  title: title,
  link: [{ rel: "canonical", href: canonical }],
  meta: [
    {
      property: "og:title",
      content: `${title.value} - ${config.public.siteName}`,
    },
    { name: "description", content: description },
  ],
});
</script>
